<template>
  <div class="ViewSentEmailsDetailList">
    <div class="container-fluid">
      <div class="table-responsive margin-Top-3Perc margin-left-3Perc margin-right-1Point1Perc">
        <table class="table table-striped width-98Point2Perc">
          <thead>
            <tr>
              <th class="text-align-center text-valign-middle font-size-15px border-right">Sr. No.</th>
              <th class="text-align-center text-valign-middle font-size-15px border-right">Cohort</th>
              <th class="text-align-center text-valign-middle font-size-15px border-right">From</th>
              <th class="text-align-center text-valign-middle font-size-15px border-right">Subject</th>
              <th class="text-align-center text-valign-middle font-size-15px border-right">Template</th>
              <th class="text-align-center text-valign-middle font-size-15px border-right">Emails Sent</th>            
              <th class="text-align-center text-valign-middle font-size-15px ">Sent TS</th>           
          </tr>
            
          </thead>
          <tbody>
            <tr v-for="(viewSentEmailObj,index) in getViewSentEmailList" :key="viewSentEmailObj.SentEmailId" v-bind:viewSentEmailObj="viewSentEmailObj"> 
              <td class="text-align-center border-right">{{index + 1}}</td>
              <td class="text-align-center border-right padding-top-2Perc">{{viewSentEmailObj.Course}}</td>
              <td class="text-align-center border-right padding-top-2Perc">{{viewSentEmailObj.FromEmail}}</td>
              <td class="text-align-center border-right padding-top-2Perc">{{viewSentEmailObj.Subject}}</td>
              <td class="text-align-center border-right padding-top-2Perc cursor-pointer text-decoration-underline" @click="updateSelectedObj($event,viewSentEmailObj,1)">{{viewSentEmailObj.EmailTemplate}}</td>
              <td class="text-align-center border-right padding-top-2Perc cursor-pointer text-decoration-underline" @click="updateSelectedObj($event,viewSentEmailObj,2)">{{getTotalSentMailCount(viewSentEmailObj.ToUserEmails)}}</td>
              <td class="text-align-center padding-top-2Perc">{{formatAndShowDate(viewSentEmailObj.SentTS)}}</td>
            </tr>
          </tbody>
       </table>
     </div>
    </div>
    <view-template-details-overlay v-if="showDetailsOverlay" @closeOverlay="closeViewTemplateOverlay" v-bind:selectedSentEmailObj="selectedSentEmailObj"></view-template-details-overlay>
    <view-sent-emailid-overlay v-if="showSentEmailOverlay" @closeOverlay="closeViewTemplateOverlay" v-bind:selectedSentEmailObj="selectedSentEmailObj"></view-sent-emailid-overlay>
  </div>
</template>

<script>
import { dmAdminUtils } from '@/utils/dmAdminUtils'
import ViewTemplateDetailsOverlay from '@/components/emails/template/ViewTemplateDetailsOverlay'
import ViewSentEmailIdOverlay from '@/components/emails/view_sent_emails/ViewSentEmailIdOverlay'
export default {
  props: ['viewSentEmailList'],
  data: function () {
    return {
      selectedSentEmailObj: null,
      showDetailsOverlay: false,
      showSentEmailOverlay: false
    }
  },
  components: {
    'view-template-details-overlay': ViewTemplateDetailsOverlay,
    'view-sent-emailid-overlay': ViewSentEmailIdOverlay
  },
  computed: {
    getViewSentEmailList: {
      get: function () {
        return this.viewSentEmailList
      }
    }
  },
  methods: {
    formatAndShowDate: function (date) {
      var dateToPass = date
      if (dateToPass.indexOf('Z') === -1) {
        dateToPass += 'Z'
      }
      return dmAdminUtils.covertUtcToEst(dateToPass)
    },
    getTotalSentMailCount: function (sentEmailIdList) {
      return sentEmailIdList.split(',').length
    },
    updateSelectedObj: function ($event, selectedObj, selectedOperation) {
      // AK: Update selected obj
      this.selectedSentEmailObj = selectedObj
      // AK: disable background scrolling
      this.$store.state.isOverlayVisible = true
      switch (parseInt(selectedOperation)) {
        case 1:
          // AK: Show Overlay to user
          this.showDetailsOverlay = true
          break
        case 2:
          // AK: Show Overlay to user
          this.showSentEmailOverlay = true
          break
      }
    },
    closeViewTemplateOverlay (flagToUpdate) {
      // AK: Used to close view template overlay
      this.showDetailsOverlay = flagToUpdate
      this.showSentEmailOverlay = flagToUpdate
      // AK: Enable background scrolling
      this.$store.state.isOverlayVisible = flagToUpdate
    }
  },
  name: 'ViewSentEmailsDetailList'
}
</script>

<style scoped>
.cursor-pointer {
  cursor: pointer;
}
.text-decoration-underline {
  text-decoration: underline;
}
.text-align-center {
 text-align: center !important;
}
.text-valign-middle{
  vertical-align: middle;
}
.font-size-15px {
  font-size: 15px !important;
}
.border-right
 {
   border-right: 1px solid #aaa !important;
 }
.margin-Top-1Perc
{
	margin-top: 1%;
}
.margin-Top-3Perc
{
	margin-top: 3%;
}
.margin-left-3Perc
{
	margin-left: 3%;
}
.margin-right-1Point1Perc
{
	margin-right: 1.1%;
}
.table-striped > tbody > tr:nth-child(2n + 1) > td,
  .table-striped > tbody > tr:nth-child(2n + 1) > th {
  background-color: #ddd;
}
.table>thead>tr>th {
    vertical-align: bottom;
    border-bottom: 0px solid #aaaaaa;
}
.width-98Point2Perc{
  width:98.2% !important;
}

</style>



// WEBPACK FOOTER //
// src/components/emails/view_sent_emails/ViewSentEmailsDetailsList.vue